export const googleTranslateAPIKey = process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY;
export const googleTranslateRestrictedAccounts = process.env.REACT_APP_GOOGLE_TRANSLATE_RESTRICTED_ACCOUNTS;

export const googleTranslate = require('google-translate')(googleTranslateAPIKey);
